import { toast, Toaster } from "sonner";
export { toast, Toaster };
/** Shared notification API; Sonner owns rendering, stacking, and dismissal. */
export const customToast = {
    success: (message, options) => toast.success(message, { id: options?.id, duration: options?.timeout, action: options?.action }),
    error: (message, options) => toast.error(message, { id: options?.id, duration: options?.timeout }),
    loading: (message, options) => toast.loading(message, { id: options?.id, duration: options?.timeout }),
    info: (message, options) => toast.info(message, { id: options?.id, duration: options?.timeout }),
};
